import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { Http } from "../../../../utilities/axios/http"
import { ContainerTypePageState, NewContainerTypeRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

/*  export const postNewContainerType = (data: NewContainerTypeRequest) => {
   return iAxios.post(API_URLs.settings.containerType.postContainerType, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const getContainerTypeList = (pageState: ContainerTypePageState) => {
  const obj: any = {...pageState}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  return iAxios.get(API_URLs.settings.containerType.getContainerTypes + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getContainerTypeById = (id: string) => {
  return iAxios.get(API_URLs.settings.containerType.getContainerTypeById?.replace('{id}', id))
  .then(r => r.data)
  .catch(e => null)
}

export const patchContainerTypeById = (id: string, data: NewContainerTypeRequest) => {
  return iAxios.patch(API_URLs.settings.containerType.patchContainerTypeById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => r.data)
  .catch(e => null)
}

export const deleteContainerTypeById = (id: string) => {
  return iAxios.delete(API_URLs.settings.containerType.deleteContainerTypeById?.replace('{id}', id))
  .then(r => ({success: true, data: r.data}))
  .catch(e => null)
}

export const getContainerUnits = () => {
  return iAxios.get(API_URLs.settings.containerType.getContainerUnitsForSelect)
  .then(r => r.data)
  .catch(e => null)
}

export const getContainerCategories = () => {
  return iAxios.get(API_URLs.settings.containerType.getContainerCategoryForSelect)
  .then(r => r.data)
  .catch(e => null)
} */

export class ContainerTypeService {
  static getContainerTypeById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.containerType.containerTypeUrl}/${id}`)
    } catch (error) {
      return error;
    }
  }

  static getContainerTypeList = async  (params?: any)  => {
    try {
      return await Http.get(API_URLs.settings.containerType.containerTypeUrl, params);
    } catch (error) {
      return error;
    }
  }

  static createContainerType = async  (data: any) => {
    try {
      return await  Http.post(API_URLs.settings.containerType.containerTypeUrl, data);
    } catch (error) {
      return error;
    }
  }

  static updateContainerType = async  (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.containerType.containerTypeUrl, data);
    } catch (error) {
        return error;      
    }
  }

  static deleteContainerType = async (id: number) => {
    try {
      return await Http.delete(API_URLs.settings.containerType.containerTypeUrl, id)
    } catch (error) {
      return error;
    }
  }

  static getContainerCategories = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.containerType.getContainerCategoryForSelect, params)
    } catch (error) {
      return error
    }
  }

  static getContainerUnits = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.containerType.getContainerUnitsForSelect, params)
    } catch (error) {
      return error;
    }
  }

  static getContainerTypeForSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.containerType.getContainerTypesForSelect, params);
    } catch (error) {
      return error;
    }
  }
}